import React, { Component } from "react";

import Button from "react-bootstrap/Button";
import { MdClose } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import styled from "styled-components";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  border-top: solid 2px lightgray;
  width: 100%;
  padding: 20px;
`;

const ModalBody = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ErrorContainer = styled.div`
  color: red;
  padding: 10px;
  display: flex;
  justify-content: center;
`;

class ConfirmationModal extends Component {
  state = {};
  render() {
    const {
      show,
      onHide,
      title,
      icon,
      buttonYes,
      buttonNo,
      onConfirm,
      error
    } = this.props;
    return (
      <Modal show={show} onHide={onHide}>
        <ModalBody>
          {icon}
          <h2>{title}</h2>
        </ModalBody>
        <ButtonContainer>
          <Button variant={buttonYes} onClick={onConfirm}>
            Yes
          </Button>
          <Button variant={buttonNo} onClick={onHide}>
            No
          </Button>
        </ButtonContainer>
        {error && <ErrorContainer>{error}</ErrorContainer>}
      </Modal>
    );
  }
}

ConfirmationModal.defaultProps = {
  show: false,
  title: "Delete project?",
  icon: <MdClose fontSize={30} color="red" />,
  buttonYes: "danger",
  buttonNo: "primary",
  onHide: () => console.log("Dev didn't provide a close function!"),
  onConfirm: () => console.log("Dev didn't provide a close function!"),
  error: "Project not found"
};

export default ConfirmationModal;
